import OrbitApiV1 from 'api/orbitV1'

class AuthFaberApi {
  static validateToken({ faberToken: faberToken }) {
    return OrbitApiV1.httpPost(
      '/faber/auth/validate',
      {},
      { token: faberToken }
    )
  }
}

export default AuthFaberApi
